import styled from "styled-components";
import { deviceDF } from "utils/breakPoints";

export const ColumnContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    flex-wrap: wrap;
    @media ${deviceDF.tablet} {
        flex-direction: column;
    }
`;